import { PROJECTS_DATA } from "common-ui/lib/common/Constant";

const projectArray = (state = [], action) => {
    switch (action.type) {
        case PROJECTS_DATA:
            return {
                ...state,
                projectArray: action.payload
            }
        default: {
            return state;
        }
    }
}

export default projectArray;